import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bda9ad4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ojQuestionPage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = ["innerHTML"]

import { ref, watchEffect } from "vue";
import { Message } from "@arco-design/web-vue";
import CodeEditor from "@/components/CodeEditor.vue";
import { getOjQuestionDetailUsingGet } from "@/api/ojQuestionController";
import API from "@/api";
import {
  getOjCodeLanguageColor,
  getOjDifficultyColor,
  getOjStatusColor,
  getOjTagColor,
  OJ_DIFFICULTY_MAP,
} from "@/constant/oj";
import { dayjs } from "@arco-design/web-vue/es/_utils/date";
import {
  addOjSubmitUsingPost,
  getOjSubmitVoListUsingPost,
  getOjSubmitVoUsingGet,
} from "@/api/ojSubmitController";
import { getCodeSandboxLanguageUsingGet } from "@/api/codeSandboxController";
import { useLoginUserStore } from "@/store/userStore";

import CodeSandboxLanguage = API.CodeSandboxLanguage;
interface Props {
  id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OjQuestionPage',
  props: {
    id: { default: () => {
    return "";
  } }
  },
  setup(__props: any) {

const props = __props;

// 代码编辑器
const language = ref("java");
const code = ref("");
const theme = ref("vs-dark");
const onChange = (value: string) => {
  code.value = value;
};

const ojQuestionDetail = ref<API.OjQuestionDetailVO>({});
const languageList = ref<CodeSandboxLanguage[]>([]);

const loginUserStore = useLoginUserStore();
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.id) {
    return;
  }
  const res = await getOjQuestionDetailUsingGet({
    id: props.id as any,
  });
  if (res.data.code === 200) {
    ojQuestionDetail.value = res.data.data as any;
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

const getLanguageList = async () => {
  const res = await getCodeSandboxLanguageUsingGet();
  if (res.data.code === 200) {
    languageList.value = res.data.data as any;
  } else {
    Message.error("提交失败，" + res.data.message);
  }
};

const columns = [
  {
    title: "提交语言",
    slotName: "language",
    align: "center",
    width: 100,
  },
  {
    title: "提交状态",
    slotName: "status",
    align: "center",
    width: 100,
  },
  {
    title: "时间消耗",
    dataIndex: "timeUsed",
    align: "center",
    width: 100,
  },
  {
    title: "内存消耗",
    dataIndex: "memoryUsed",
    align: "center",
    width: 100,
  },
  {
    title: "提交时间",
    slotName: "createTime",
    align: "center",
    width: 100,
  },
];

// 初始化搜索条件
const initSearchParams = {
  current: 1,
  pageSize: 5,
};
const searchParams = ref<API.OjSubmitQueryRequest>({
  ...initSearchParams,
});
const total = ref<number>(0);
const submitHistoryData = ref([]);

const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
  getSubmitHistoryData();
};

const handleTabClick = (key: number) => {
  if (key == 3) {
    getSubmitHistoryData();
  }
};

const getSubmitHistoryData = async () => {
  const res = await getOjSubmitVoListUsingPost({
    ...searchParams.value,
  });
  if (res.data.code === 200) {
    submitHistoryData.value = res.data.data?.records as any;
    total.value = res.data.data?.total as any;
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

const runBtn = async () => {
  console.log(code.value);
};

const submitLoading = ref(false);
const submitBtn = async () => {
  console.log(code.value);
  const res = await addOjSubmitUsingPost({
    questionId: props.id as any,
    code: code.value,
    language: language.value,
  });
  if (res.data.code === 200) {
    submitLoading.value = true;
    var timer = setInterval(async () => {
      const result = await getSubmitData(res.data.data);
      if (result) {
        clearInterval(timer);
        submitLoading.value = false;
      }
    }, 1500);
  } else {
    Message.error("提交失败，" + res.data.message);
  }
};
const submitData = ref<API.OjSubmitVO>({});
const getSubmitData = async (id: any) => {
  const res = await getOjSubmitVoUsingGet({
    id,
  });
  if (res.data.code === 200 && res.data.data.judgeStatus == 2) {
    submitData.value = res.data.data as any;
    return true;
  }
  return false;
};

watchEffect(() => {
  loadData();
  getLanguageList();
});

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_collapse_item = _resolveComponent("a-collapse-item")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_scrollbar = _resolveComponent("a-scrollbar")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (ojQuestionDetail.value.id)
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 0,
          gutter: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tabs, {
                  type: "card",
                  class: "tab",
                  onTabClick: handleTabClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      class: "tabPane",
                      key: "1",
                      title: "题目描述"
                    }, {
                      default: _withCtx(() => [
                        (ojQuestionDetail.value.content)
                          ? (_openBlock(), _createBlock(_component_a_scrollbar, {
                              key: 0,
                              style: {"overflow":"auto","margin-bottom":"10px","height":"50vh","padding":"10px"},
                              class: "scrollbar"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { style: {"width":"100%","text-align":"center"} }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, _toDisplayString(ojQuestionDetail.value.title), 1),
                                    _createVNode(_component_a_tag, {
                                      bordered: "",
                                      color: _unref(getOjDifficultyColor)(ojQuestionDetail.value.difficulty)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(OJ_DIFFICULTY_MAP)[ojQuestionDetail.value.difficulty]), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color"])
                                  ]),
                                  _: 1
                                }),
                                _hoisted_2,
                                _createVNode(_component_a_space, { class: "tags" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ojQuestionDetail.value.tags, (tag) => {
                                      return (_openBlock(), _createBlock(_component_a_tag, {
                                        color: _unref(getOjTagColor)(tag),
                                        key: tag
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(tag), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", {
                                  innerHTML: ojQuestionDetail.value.content,
                                  class: "content"
                                }, null, 8, _hoisted_3),
                                _createVNode(_component_a_descriptions, {
                                  column: 2,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_descriptions_item, { label: "时间限制" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(ojQuestionDetail.value?.timeLimit), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, { label: "内存限制" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(ojQuestionDetail.value?.memoryLimit), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (ojQuestionDetail.value.tips)
                                  ? (_openBlock(), _createBlock(_component_a_collapse, {
                                      key: 0,
                                      accordion: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ojQuestionDetail.value.tips, (tip, index) => {
                                          return (_openBlock(), _createBlock(_component_a_collapse_item, {
                                            header: 
                    ojQuestionDetail.value.tips.length > 1 ? `Tip${index + 1}` : 'Tip'
                  ,
                                            key: index
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(tip), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["header"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      class: "tabPane",
                      key: "2",
                      title: "题目答案"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("无")
                      ]),
                      _: 1
                    }),
                    (_unref(loginUserStore).loginUser.id)
                      ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                          class: "tabPane",
                          key: "3",
                          title: "提交记录"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_table, {
                              columns: columns as any,
                              data: submitHistoryData.value,
                              pagination: {
                showTotal: true,
                pageSize: searchParams.value.pageSize,
                current: searchParams.value.current,
                total: total.value,
              },
                              onPageChange: onPageChange
                            }, {
                              language: _withCtx(({ record }) => [
                                _createVNode(_component_a_tag, {
                                  color: _unref(getOjCodeLanguageColor)(record.language)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(record.language), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              status: _withCtx(({ record }) => [
                                _createVNode(_component_a_tag, {
                                  color: _unref(getOjStatusColor)(record.status)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(record.status), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              createTime: _withCtx(({ record }) => [
                                _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("HH:mm:ss")), 1)
                              ]),
                              _: 1
                            }, 8, ["columns", "data", "pagination"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  modelValue: language.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
                  style: {"width":"10vw","margin-bottom":"1vh"},
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_option, {
                        label: item.text,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_a_select, {
                  modelValue: theme.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((theme).value = $event)),
                  style: {"width":"10vw","margin-bottom":"1vh"},
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_option, {
                      label: "vs",
                      value: "vs"
                    }),
                    _createVNode(_component_a_option, {
                      label: "vs-dark",
                      value: "vs-dark"
                    }),
                    _createVNode(_component_a_option, {
                      label: "hc-dark",
                      value: "hc-dark"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(CodeEditor, {
                    style: {"height":"50vh"},
                    language: language.value,
                    value: code.value,
                    theme: theme.value,
                    "handle-change": onChange
                  }, null, 8, ["language", "value", "theme"])
                ]),
                _createVNode(_component_a_space, { class: "btn" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      onClick: runBtn,
                      type: "outline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("运行")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      onClick: submitBtn,
                      type: "primary",
                      loading: submitLoading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("提交")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})